'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = search;
exports.reverse = reverse;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _lonlng4 = require('lonlng');

var _lonlng5 = _interopRequireDefault(_lonlng4);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapzen_url = 'https://search.mapzen.com/v1';
var search_url = mapzen_url + '/search';
var reverse_url = mapzen_url + '/reverse';

function search(api_key, text) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var boundary = _ref.boundary;
  var focusLatlng = _ref.focusLatlng;
  var format = _ref.format;

  if (!text) return Promise.resolve([]);

  var query = {
    api_key: api_key,
    text: text
  };

  if (focusLatlng) {
    var _lonlng = (0, _lonlng5.default)(focusLatlng);

    var lat = _lonlng.lat;
    var lng = _lonlng.lng;

    query['focus.point.lat'] = lat;
    query['focus.point.lon'] = lng;
  }

  if (boundary) {
    if (boundary.country) query['boundary.country'] = boundary.country;
    if (boundary.rect) {
      var min = (0, _lonlng5.default)(boundary.rect.minLatlng);
      var max = (0, _lonlng5.default)(boundary.rect.maxLatlng);
      query['boundary.rect.min_lat'] = min.lat;
      query['boundary.rect.min_lon'] = min.lng;
      query['boundary.rect.max_lat'] = max.lat;
      query['boundary.rect.max_lon'] = max.lng;
    }
    if (boundary.circle) {
      var _lonlng2 = (0, _lonlng5.default)(boundary.circle.latlng);

      var lat = _lonlng2.lat;
      var lng = _lonlng2.lng;

      query['boundary.circle.lat'] = lat;
      query['boundary.circle.lon'] = lng;
      query['boundary.circle.radius'] = boundary.circle.radius;
    }
  }

  return run(search_url, query, format);
}

function reverse(api_key, latlng) {
  var _ref2 = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var format = _ref2.format;

  var _lonlng3 = (0, _lonlng5.default)(latlng);

  var lng = _lonlng3.lng;
  var lat = _lonlng3.lat;

  return run(reverse_url, {
    api_key: api_key,
    'point.lat': lat,
    'point.lon': lng
  }, format);
}

function run(url, query, format) {
  return (0, _isomorphicFetch2.default)(url + '?' + _qs2.default.stringify(query)).then(function (res) {
    return res.json();
  }).then(function (json) {
    return json && json.features && format ? json.features.map(split) : json;
  });
}

function split(_ref3) {
  var geometry = _ref3.geometry;
  var properties = _ref3.properties;

  return Object.assign({}, properties, {
    address: properties.label,
    latlng: _lonlng5.default.fromCoordinates(geometry.coordinates)
  });
}


/** WEBPACK FOOTER **
 ** ./~/isomorphic-mapzen-search/build/index.js
 **/